import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { clearSuccessfulLead, saveSuccessfulLead } from "../utils/leadConversionTracking.js";
import Loading from "./Loading.js";
import { OverlayLoader } from "./OverlayLoader.js";
import { useNavigate } from "react-router-dom";

function BookingScanPopup({ isOpen, onClose, selectedProduct, bookScanPage = false , formType  = 'scan'}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sucessMessage, setSucessMessage] = useState(null);
  const [errors, setErrors] = useState({});
  const [cityList, setCityList] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    city: "",
    otp: "",
    isConsent: true,
  });
  const [agreeChecked, setAgreeChecked] = useState(false);

  const errorRef = useRef(null);

  const [isSubmit, setIsSubmit] = useState(false);
  const [otpMessage, setOtpMessage] = useState(null);
  const [timer, setTimer] = useState(120);
  const [timerActive, setTimerActive] = useState(true);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [otp, setOtp] = useState("");
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    let intervalId; 
    if (isOpen) {
      // document.body.classList.remove('scroll');
      if(bookScanPage === false)
      document.body.classList.add("modal-open");

      intervalId = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 0) {
            clearInterval(intervalId);
            setTimerActive(false);
            return 0;
          } else {
            return prevTimer - 1;
          }
        });
      }, 1000);

      getcityList();
     
    }
    return () => clearInterval(intervalId); 
  }, [isOpen, timerActive, isSubmit]);

  if (!isOpen) return null;

  const getcityList = async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}getSelectedLocation/${formType}`
      );
      const data = result.data.data;
      setCityList(data);
    } catch (error) {
    } finally {
    }
  };

  const closePopup = () => {
    onClose();
    setErrors({});
    // document.body.classList.remove('scroll');
    document.body.classList.remove("modal-open");
    clearForm();
  };


  const clearForm = () => {
    setFormData({
      name: "",
      phoneNumber: "",
      otp: "",
      isConsent: true,
    });
    setIsSubmit(false)
  };

  

  

  const handleInputChange = (event) => {
    let { name, value, checked } = event.target;

    if (name === "phoneNumber") {
      value = value.replace(/[^0-9]/g, "");
    }
    if (name === "otp") {
      value = value.replace(/[^0-9]/g, "");
    }
    if (name === "name" && !/^[a-zA-Z\s]*$/.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Name is required",
      }));
      return;
    }

    setFormData({
      ...formData,
      [name]: name === "isConsent" ? checked : value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    if (!value.trim().length && name === "name") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Name is required",
      }));
    }

    if (name === "otp") {
      setEnteredOtp(value);
    }

    if (name === "phoneNumber") {
      if (value.length > 0) {
        if (!/^\d{10}$/.test(value)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Phone number must be 10 digits ",
          }));
        } else if (!/^[6-9][0-9]{9}$/.test(value)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Invalid phone number",
          }));
        }
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Phone number is required",
        }));
      }
    }else if (name === "isConsent") {
      if (!checked) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "You must agree to the terms",
        }));
      } else {
        setAgreeChecked(true)
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "", // Clear error message
        }));
      }
    }
    if (name === "otp" && !value.trim().length) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Otp is required",
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    } else if (!/^[6-9][0-9]{9}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Invalid phone number";
    }

    if (!formData.city || !formData.city.trim()) {
      newErrors.city = "City is required";
    }

    if (!formData.isConsent) {
      newErrors.isConsent = "You must agree to the terms";
    }
    return newErrors;
  };

  const handleBookingForm = async (event) => {
    try {
      event.preventDefault();
      clearSuccessfulLead();
      const newErrors = validateForm();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        if (errorRef.current) {
          errorRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      } else {
        setLoading(true);
        setErrors(newErrors);
      }
      const otpResponse = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}sendOtpRequest`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          name: formData.name,
          mobile: formData.phoneNumber,
        },
      });

      if (otpResponse.status === 201) {
        setSucessMessage("OTP request sent successfully");
        const receivedOtp = otpResponse?.data?.data?.otp;
        setOtp(receivedOtp);

        setTimeout(() => {
          setLoading(false)
          setIsSubmit(true);
          setTimer(120);
          setSucessMessage(null);
        }, 1000);
      } else {
        setSucessMessage("OTP  sent request failed");
        setIsSubmit(true);
        setLoading(false)
        setTimeout(() => {
          setSucessMessage(null);
        }, 500);
        console.error("Failed to submit form: ", otpResponse.status);
      }
    } catch (error) {
      setSucessMessage("OTP  sent request failed");
      setIsSubmit(true);
      setLoading(false)

      setTimeout(() => {
        setSucessMessage(null);
      }, 500);
      console.error("Error submitting form: ", error);
    }
  };



  const handleVerifyOtp = async(event) => {
    event.preventDefault();
    if (!timerActive) {
      return; 
    }
    const enteredOtp = formData.otp;

    if (!formData.name.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: "Name is required",
      }));
      return;
    }

    if (!formData.phoneNumber.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phoneNumber: "Phone number is required",
      }));
      return;
    }
    if (formData.phoneNumber.length > 0) {
      if (!/^\d{10}$/.test(formData.phoneNumber)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phoneNumber: "Phone number must be 10 digits",
        }));
        return;
      } else if (!/^[6-9][0-9]{9}$/.test(formData.phoneNumber)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          phoneNumber: "Invalid phone number",
        }));
        return;
      }
    }
    if (!formData.city.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        city: "City is required",
      }));
      return;
    }

    if (!enteredOtp.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        otp: "OTP is required",
      }));
      return;
    } else {
      setLoading(true)

    }
    const enteredOtpNumber = parseInt(enteredOtp);
    const otpNumber = parseInt(otp);

        // Extract parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const gclid = urlParams.get('gclid');

    if (enteredOtpNumber === otpNumber) {
      setOtpMessage("OTP Verified");
      setVerified(true);

      try{
      const bookingResult = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}addProductBooking`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          name: formData.name,
          mobile: formData.phoneNumber,
          city: formData.city,
          product_id: selectedProduct,
          dnd_override_status: agreeChecked,
          utm_source: utmSource,
          utm_medium: utmMedium,
          utm_campaign: utmCampaign,
          gclid: gclid,
          form_type: formType,
        },
      });


      if (bookingResult.status === 201) {
        saveSuccessfulLead({
          name: formData.name,
          phone: formData.phoneNumber,
          city: formData.city,
        });
        setSucessMessage("Booking Data has been successfully added");

        setTimeout(() => {
          navigate("/thank-you");
          setSucessMessage(null);
          closePopup();
        }, 1000);
        setFormData({
          name: "",
          phoneNumber: "",
          otp: "",
        });
        setLoading(false);
      } else {
        console.error("Failed to submit form: ", bookingResult.status);
        setSucessMessage("Booking Data has been successfully added");
        setTimeout(() => {
          navigate("/thank-you");
          setSucessMessage(null);
          closePopup();
        }, 1000);
        setLoading(false);
      }
   
      // setSucessMessage("OTP Verified")

      setTimer(0);

      setTimeout(() => {
        setTimerActive(false);
        setLoading(false);
        setSucessMessage(null)
        setOtpMessage(null);
        navigate("/thank-you");
      }, 1000);
    } catch{
      // console.error("Failed to submit form: ", bookingResult.status);
      setSucessMessage("Booking Data has been successfully added");
      setTimeout(() => {
        navigate("/thank-you");
        setSucessMessage(null);
        closePopup();
      }, 1000);
      setLoading(false);
  }
}
    else {
      setOtpMessage("OTP Verification Failed");
      // setSucessMessage("OTP Verification Failed");
      setTimeout(() => {
        setLoading(false);
        // setSucessMessage(null);
        setOtpMessage(null);
      }, 3000);
    }
  };


  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  const handleResendClick = async (event) => {
 
    event.preventDefault();
    if (timerActive) {
      return; 
    }
    setLoading(true);
    try {
      const resendResult = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}sendOtpRequest`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          name: formData.name,
          mobile: formData.phoneNumber,
        },
      });

      if (resendResult.status === 201) {
        setOtp(resendResult.data?.data?.otp);
        setOtpMessage("OTP resend successfully")
        setTimer(120);
        setTimerActive(true);
        setLoading(false);
        setTimeout(()=>{
          setOtpMessage(null)
        },3000)
      } else {
        setOtpMessage("OTP resend request failed")
        console.error("Failed to resend OTP: ", resendResult.status);
        setLoading(false);
        setTimeout(()=>{
          setOtpMessage(null)
        },1500)
      }
    } catch (error) {
      setOtpMessage("OTP resend request failed")
      console.error("Error resending OTP: ", error);
      setLoading(false);
      setTimeout(()=>{
        setOtpMessage(null)
      },1500)
    }
  };

  return (
    <div className="popup_call">
      <div className="ct">
        <div className="cl">
          <img
            onClick={closePopup}
            src="/images/frm_close.svg"
            alt="close-img"
            loading="lazy"
          />
        </div>
        <div className="lts"></div>
        <div
          className={`rt position-relative ${loading ? "overflow-hidden" : ""}`}
        >
          {loading && <OverlayLoader />}
          <form onSubmit={handleBookingForm}>
            {sucessMessage && (
              <div className="alert alert-success" role="alert">
                {sucessMessage}
              </div>
            )}

            <div className="t1">
              <span>Start your smile</span> transformation
            </div>
            <div className="t2">
              <span>Book a Free</span> 3D Scan & Ortho Consult at{" "}
              <span>Home</span>
            </div>
            <div className="bx">
              <div className="ic">
                <img src="/images/frm_name.svg" alt="name-img" loading="lazy" />
              </div>
              <input
                className="inp"
                type="text"
                placeholder="enter your name *"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                maxLength={50}
                ref={errors.name ? errorRef : null}
              />
            </div>
            {errors.name && <div className="error">{errors.name}</div>}

            <div className="bx ph">
              <div className="ic">
                <img src="/images/frm_phone.svg" alt="phone-img" loading="lazy" />
              </div>
              <div className="cc">+91</div>
              <input
                className="inp"
                type="text"
                placeholder="enter mobile number *"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                maxLength={15}
              />
            </div>
            {errors.phoneNumber && (
              <div className="error">{errors.phoneNumber}</div>
            )}

            <div className="bx">
              <div className="ic">
                <img src="/images/frm_city.svg" alt="city-img" loading="lazy" />
              </div>

              <select
                name="city"
                value={formData.city}
                onChange={handleInputChange}
              >
                <option value="">Choose City</option>
                {cityList.map((city, index) => {
                  return (
                    <option key={index} value={city.city}>
                      {city.city}
                    </option>
                  );
                })}
              </select>
            </div>
            {errors.city && <div className="error">{errors.city}</div>}

            {!isSubmit && (
              <>
                <div className="agree">
                  <div className="l">
                    <label className="frm_cnt">
                      <input
                        type="checkbox"
                        name="isConsent"
                        checked={formData.isConsent}
                        onChange={(e) =>
                          setFormData({ ...formData, isConsent: e.target.checked })
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="r">
                    I give my consent to receive information about products and services from Whistle, its affiliates and business partners', by telephone / emails / messages, or other digital means
                  </div>
                </div>
                {errors.isConsent && (
                  <div className="error">{errors.isConsent}</div>
                )}
                <button type="submit">Send OTP</button>
              </>
            )}

            {isSubmit && (
              <>
                <div className="bxs-otp">
                  {/* <div className="ic">
                       
                      </div> */}
                  <input
                    className="inp otp-input"
                    type="text"
                    placeholder="Enter OTP *"
                    name="otp"
                    value={formData.otp}
                    onChange={handleInputChange}
                    maxLength={6}
                  />
                </div>
                {otpMessage && (
                  <div
                    className={`otp-message ${
                      otpMessage === "OTP Verification Failed"
                        ? "failed-message"
                        : ""
                    }`}
                  >
                    {otpMessage}
                  </div>
                )}
                {errors.otp && <div className="error">{errors.otp}</div>}
                <div className="fd4">
                  You can resend OTP after:
                  {minutes < 10 ? "0" : ""}
                  {minutes}:{seconds < 10 ? "0" : ""}
                  {seconds}
                  {/* You can resend OTP after : 00:00 */}
                </div>
                <div className="otp-button">
                  {verified ? (
                    <button
                      className={`r1 ${!timerActive ? 'disabled-button' : ''}`}
                      onClick={handleResendClick}
                    >
                     Resend
                    </button>
                  ) : (
                    <button
                      className={`r1 ${timerActive ? 'disabled-button' : ''}`}
                      onClick={handleResendClick}
                    >
                     Resend
                    </button>
                  )}

                  <button
                    className={`r1 ${!timerActive ? 'disabled-button' : ''}`}
                    onClick={handleVerifyOtp}
                  >
                    Verify OTP
                  </button>
                </div>
                <div className="agree">
                  <div className="l">
                    <label className="frm_cnt">
                      <input
                        type="checkbox"
                        name="isConsent"
                        checked={formData.isConsent}
                        onChange={(e) =>
                          setFormData({ ...formData, isConsent: e.target.checked })
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="r">
                    I give my consent to receive information about products and services from Whistle, its affiliates and business partners', by telephone / emails / messages, or other digital means
                  </div>
                </div>
                {errors.isConsent && (
                  <div className="error">{errors.isConsent}</div>
                )}
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
export default BookingScanPopup;
